export default __webpack_public_path__ + "ca42feeb1be887863b89f5c46955390c.svg";